import { Row } from 'hatch-components';
import BoardAvatar from 'root/components/molecules/BoardAvatar';
import styled from 'styled-components';

export const StyledWorkspaceTeamList = styled(Row)(() => ({
  alignItems: 'center',
  flexWrap: 'nowrap',
  height: 38,
}));

export const StyledAvatarWrapper = styled(Row)(
  ({
    theme: {
      border,
      colors,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    '&:first-child': {
      marginLeft: 0,
    },
    alignItems: 'center',
    border: `1px solid ${colors.white}`,
    borderRadius: border.radius.sm,
    height: '38px',
    justifyContent: 'center',
    marginLeft: `-${spacing.xxs}`,
    [mobile]: {
      height: '30px',
      width: '30px',
    }, // for css zIndexing properly
    position: 'relative',
    width: '38px',
  }),
);

export const StyledBoardAvatar = styled(BoardAvatar)(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    height: 36,
    lineHeight: '16px',
    [mobile]: {
      height: 28,
      width: 28,
    },
    width: 36,
  }),
);

export const StyledRemainingWorkspaces = styled.div(
  ({
    theme: {
      border,
      colors,
      font,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    alignItems: 'center',
    background: colors.white,
    border: `1px solid ${colors.primary}`,
    borderRadius: border.radius.sm,
    cursor: 'pointer',
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'nowrap',
    height: 36,
    justifyContent: 'center',
    marginLeft: `-${spacing.xxs}`,
    [mobile]: {
      fontSize: font.size.xxs,
      height: 28,
      lineHeight: font.lineHeight.xxs,
      width: 28,
    },
    position: 'relative',
    width: 36,
  }),
);

export const StyledRemainingWorkspacesCount = styled.p(
  ({ theme: { colors, font } }) => ({
    color: colors.primary,
    fontSize: font.size.xxs,
    height: font.lineHeight.xxs,
    lineHeight: font.lineHeight.xxs,
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  }),
);
